<template>
    <MenuSideBar 
        :sidebarTheme="props.sidebarTheme"
        :sidebarCollapsed="props.sidebarCollapsed"
        :typeMenu="props.typeMenu"
    />
</template>
<script setup>
import MenuSideBar from './Menu.vue'
const props = defineProps({
    sidebarCollapsed: {
		type: Boolean,
		default: false,
	},
    sidebarTheme: {
        type: String,
        default: 'light'
    },
    typeMenu: {
        type: String,
        default: "client"
    }
})
const emit = defineEmits(['toggleSidebar']);
const updateCollapse = (show) => {
    console.log("test")
    //localSidebarCollapsed.value = !show
    emit('toggleSidebar', show)
    console.log(show)
    console.log("update " + props.sidebarCollapsed)
}
</script>